import { Form, InputNumber, message, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../api";
import { filterOption, requiredField } from "../util";

export default function ({ item, open, onCancel, onFinish}) {
    const [supplies, setSupplies] = useState([]);
    const [loading,setLoading] = useState(false)
    const [form] = Form.useForm()

    useEffect(() => {
        if (item && open) {
            axiosInstance
                .get(`contractItem/${item.contractItem.id}/supply`)
                .then(({ data }) => setSupplies(data));
        }
    }, [item,open]);
    useEffect(() =>{
        form.resetFields()
    })

    const onFormFinish = (form) => {
        setLoading(true);
        axiosInstance
            .post(`accountingItem`, {...form, supplyOf: item.id})
            .then(() => {
                message.success("Elemento aggiunto");
            })
            .then(() => onFinish?.(form))
            .finally(() => setLoading(false));
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            okButtonProps={{ form: "newLinkedSupplyItem", htmlType: "submit", loading: loading }}
            title={"Aggiungi fornitura"}
            okText={"Salva"}
        >
            <Form id="newLinkedSupplyItem" onFinish={onFormFinish} form={form} layout="vertical">
                <Form.Item
                    label={"Voce"}
                    style={{ margin: 0 }}
                    rules={[requiredField]}
                    name={"contractItem"}
                >
                    <Select
                        showSearch
                        filterOption={filterOption}
                        style={{ minWidth: "100%" }}
                        options={supplies.map((x) => ({
                            label: x.refId + " - " + x.description,
                            value: x.id,
                        }))}
                    />
                </Form.Item>
                <Form.Item
                    style={{ margin: 0 }}
                    label={"Quantità"}
                    name={"quantity"}
                    rules={[requiredField]}
                >
                    <InputNumber style={{ width: "100%" }} />
                </Form.Item>
            </Form>
        </Modal>
    );
}
